import { useState } from "react";
import { toast } from "react-toastify";
import { apiUrl } from "../../constants";
import axios from "axios";
import { scrollToTop } from "../../utils";

const TodaySalesEntry = () => {
  const [cashAmount, setCashAmount] = useState("");
  const [onlineAmount, setOnlineAmount] = useState("");
  const [creditCardAmount, setCreditCardAmount] = useState("");
  const [totalTransactions, setTotalTransactions] = useState("");
  const [date, setDate] = useState(new Date().toISOString().split("T")[0]);
  const [notes, setNotes] = useState("");

  const getTotalAmount = () => {
    const cash = parseFloat(cashAmount) || 0;
    const online = parseFloat(onlineAmount) || 0;
    const credit = parseFloat(creditCardAmount) || 0;
    return (cash + online + credit).toFixed(2);
  };

  const handleSubmit = async () => {
    // Validate required fields
    if (
      !cashAmount ||
      !onlineAmount ||
      !creditCardAmount ||
      !totalTransactions
    ) {
      alert("Please fill in all required fields");
      return;
    }

    const submitData = {
      cashAmount,
      onlineAmount,
      creditCardAmount,
      totalAmount: getTotalAmount(),
      totalTransactions,
      date,
      notes,
    };

    const res = await axios.post(`${apiUrl}/manualsales/sales`, submitData);
    if (res.data.success) {
      toast.success("Sales Entry Added");
    } else {
      toast.error("Error occured");
    }
    console.log(res, "res");
    // Reset form
    setCashAmount("");
    setOnlineAmount("");
    setCreditCardAmount("");
    setTotalTransactions("");
    setDate(new Date().toISOString().split("T")[0]);
    setNotes("");
    scrollToTop();
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-indigo-50 to-purple-50 p-4 sm:p-6 lg:p-8">
      <div className="max-w-4xl mx-auto">
        <div className="bg-white/80 backdrop-blur-sm rounded-2xl shadow-xl border border-white/20 overflow-hidden">
          {/* Header */}
          <div className="bg-gradient-to-r from-purple-600 to-indigo-600 p-6 sm:p-8">
            <h2 className="text-2xl sm:text-3xl font-bold text-white mb-2">
              📊 Today's Sales Entry
            </h2>
            <p className="text-purple-100 text-sm sm:text-base">
              Record your daily sales transactions and payments
            </p>
          </div>

          <div className="p-6 sm:p-8 space-y-6">
            {/* Date Section */}
            <div className="bg-gray-50 rounded-xl p-4 sm:p-6">
              <label className="block text-sm font-semibold text-gray-700 mb-3">
                📅 Date *
              </label>
              <input
                type="date"
                value={date}
                onChange={(e) => setDate(e.target.value)}
                required
                className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-4 focus:ring-purple-500/20 focus:border-purple-500 transition-all duration-200 text-lg"
              />
            </div>

            {/* Payment Methods Grid */}
            <div className="bg-gray-50 rounded-xl p-4 sm:p-6">
              <h3 className="text-lg font-semibold text-gray-800 mb-4 flex items-center">
                💰 Payment Breakdown
              </h3>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
                <div className="space-y-2">
                  <label className="block text-sm font-medium text-gray-700">
                    💵 Cash Amount (₹) *
                  </label>
                  <input
                    type="number"
                    value={cashAmount}
                    onChange={(e) => setCashAmount(e.target.value)}
                    placeholder="0.00"
                    step="0.01"
                    min="0"
                    required
                    className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-4 focus:ring-green-500/20 focus:border-green-500 transition-all duration-200 text-lg"
                  />
                </div>

                <div className="space-y-2">
                  <label className="block text-sm font-medium text-gray-700">
                    🌐 Online Payment (₹) *
                  </label>
                  <input
                    type="number"
                    value={onlineAmount}
                    onChange={(e) => setOnlineAmount(e.target.value)}
                    placeholder="0.00"
                    step="0.01"
                    min="0"
                    required
                    className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-4 focus:ring-blue-500/20 focus:border-blue-500 transition-all duration-200 text-lg"
                  />
                </div>

                <div className="space-y-2 sm:col-span-2 lg:col-span-1">
                  <label className="block text-sm font-medium text-gray-700">
                    💳 Credit Card (₹) *
                  </label>
                  <input
                    type="number"
                    value={creditCardAmount}
                    onChange={(e) => setCreditCardAmount(e.target.value)}
                    placeholder="0.00"
                    step="0.01"
                    min="0"
                    required
                    className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-4 focus:ring-indigo-500/20 focus:border-indigo-500 transition-all duration-200 text-lg"
                  />
                </div>
              </div>
            </div>

            {/* Total Amount Display */}
            <div className="bg-gradient-to-r from-green-500 to-emerald-600 rounded-xl p-6 text-center transform hover:scale-105 transition-transform duration-200">
              <h3 className="text-xl sm:text-2xl font-bold text-white mb-2">
                💎 Total Sales Amount
              </h3>
              <p className="text-3xl sm:text-4xl font-extrabold text-white">
                ₹{getTotalAmount()}
              </p>
            </div>

            {/* Transactions Count */}
            <div className="bg-gray-50 rounded-xl p-4 sm:p-6">
              <label className="block text-sm font-semibold text-gray-700 mb-3">
                🔢 Total Number of Transactions *
              </label>
              <input
                type="number"
                value={totalTransactions}
                onChange={(e) => setTotalTransactions(e.target.value)}
                placeholder="Enter total transactions"
                required
                min="0"
                className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-4 focus:ring-orange-500/20 focus:border-orange-500 transition-all duration-200 text-lg"
              />
            </div>

            {/* Notes Section */}
            <div className="bg-gray-50 rounded-xl p-4 sm:p-6">
              <label className="block text-sm font-semibold text-gray-700 mb-3">
                📝 Additional Notes
              </label>
              <textarea
                rows={4}
                value={notes}
                onChange={(e) => setNotes(e.target.value)}
                placeholder="Any additional notes about today's sales, special events, promotions, etc..."
                className="w-full px-4 py-3 border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-4 focus:ring-purple-500/20 focus:border-purple-500 transition-all duration-200 text-lg resize-none"
              />
            </div>

            {/* Submit Button */}
            <button
              onClick={handleSubmit}
              className="w-full bg-gradient-to-r from-purple-600 to-indigo-600 text-white py-4 px-6 rounded-xl font-semibold text-lg hover:from-purple-700 hover:to-indigo-700 focus:outline-none focus:ring-4 focus:ring-purple-500/50 transform hover:scale-105 transition-all duration-200 shadow-lg hover:shadow-xl"
            >
              ✨ Submit Sales Entry
            </button>
          </div>
        </div>

        {/* Quick Stats Card */}
        <div className="mt-6 bg-white/60 backdrop-blur-sm rounded-2xl p-6 border border-white/20">
          <h3 className="text-lg font-semibold text-gray-800 mb-4">
            📈 Quick Overview
          </h3>
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 text-center">
            <div className="bg-green-100 rounded-lg p-3">
              <p className="text-xs font-medium text-green-700">Cash</p>
              <p className="text-lg font-bold text-green-800">
                ₹{cashAmount || "0.00"}
              </p>
            </div>
            <div className="bg-blue-100 rounded-lg p-3">
              <p className="text-xs font-medium text-blue-700">Online</p>
              <p className="text-lg font-bold text-blue-800">
                ₹{onlineAmount || "0.00"}
              </p>
            </div>
            <div className="bg-indigo-100 rounded-lg p-3">
              <p className="text-xs font-medium text-indigo-700">Credit</p>
              <p className="text-lg font-bold text-indigo-800">
                ₹{creditCardAmount || "0.00"}
              </p>
            </div>
            <div className="bg-orange-100 rounded-lg p-3">
              <p className="text-xs font-medium text-orange-700">
                Transactions
              </p>
              <p className="text-lg font-bold text-orange-800">
                {totalTransactions || "0"}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TodaySalesEntry;
